





























































import { Component, Prop, Watch } from 'vue-property-decorator';
import Draggable from 'vuedraggable';

import CommonVue from '../../models/commonVue';
import { BusEvent } from '@/models/bus';
import { NamedEntity } from '@/models/store';

import ApiList from '@/api/list';

import EditIcon from '@/components/icons/EditIcon.vue';
import ArrowIcon from '@/components/icons/ArrowIcon.vue';
import DownIcon from '@/components/icons/DownIcon.vue';
import RightIcon from '@/components/icons/RightIcon.vue';
import ModulesIcon from '@/components/icons/ModulesIcon.vue';
import SkillsIcon from '@/components/icons/SkillsIcon.vue';
import TopicsIcon from '@/components/icons/TopicsIcon.vue';
// import CategoriesIcon from '@/components/icons/CategoriesIcon.vue';
import ProgramIcon from '@/components/icons/TopicsIcon.vue';
import reject from 'lodash/reject';
import Module from '@/api/module';
import Project from '@/api/project';
import LockManager from '@/models/lock';
import { isEmpty, isNil } from 'lodash';

@Component({
  components: {
    draggable: Draggable,
    'edit-icon': EditIcon,
    'arrow-icon': ArrowIcon,
    'down-icon': DownIcon,
    'right-icon': RightIcon,
    'modules-icon': ModulesIcon,
    'skills-icon': SkillsIcon,
    'topics-icon': TopicsIcon,
    // 'categories-icon': CategoriesIcon,
    'programs-icon': ProgramIcon
  }
})
export default class ListEntity extends CommonVue {
  @Prop({ type: Number }) public id?: number;
  @Prop({ type: String }) public entity!: string;
  @Prop() public list!: Promise<ApiList<NamedEntity>>;
  @Prop() public projects!: Promise<ApiList<Project>>;
  @Prop({ type: Boolean, default: false }) public isOrdering!: boolean;
  @Prop({ type: Boolean, default: false }) public isEdit!: boolean;

  public loadedList: ApiList<NamedEntity> | null = null;
  public projectList: ApiList<Project> | null = null;
  public loading = false;

  public projectDragOptions: object = {
    group: 'project',
    ghostClass: 'ghost'
  };
  public entityDragOptions: object = {
    group: 'entity',
    ghostClass: 'ghost'
  };
  public draggedElement: NamedEntity = null;
  public projectDraggedElement: Project = null;
  public moving: boolean = false;

  public selectedProjectId = null;

  // used to prevent scrolling when clicking on the list
  public ignoreUpdate: boolean = false;

  public async beforeMount() {
    this.busy = true;
    await this.loadList();
    this.busy = false;
  }

  @Watch('list')
  public async loadList() {
    this.busy = true;
    try {
      this.projectList = await this.projects;
      this.loadedList = await this.list;

      if (this.entity === Module.SLUG) {
        this.loadedList.results = reject(this.loadedList.results, (item) => {
          return item.is_program;
        });
      }
    } catch (e) {
      this.error = true;
      this.$bus.$emit(BusEvent.ERROR, 'Could not load list', e);
    } finally {
      this.busy = false;
    }
  }

  public renderModuleName(projectId) {
    if (isNil(this.projectList) || isEmpty(this.projectList.results)) return '';

    for (const project of this.projectList.results) {
      if (projectId == project.id) {
        return `[${project.getName()}]`;
      }
    }
  }

  public updated() {
    if (!this.ignoreUpdate) {
      this.scrollToElement();
      this.ignoreUpdate = true;
    }
  }

  public scrollToElement() {
    if (
      this.$refs.scrollElement &&
      (this.$refs.scrollElement as any[]).length === 1
    ) {
      this.$refs.scrollElement[0].scrollIntoView();
    }
  }

  public lineClicked(id: number) {
    if (this.entity === this.MODULE_SLUG && !this.isEdit) {
      this.$router.push(`/${this.MODULE_SLUG}/${id}/${this.LESSON_SLUG}`);
    } else if (this.entity === this.PROJECT_SLUG && !this.isEdit) {
      this.$router.push(`/${this.PROJECT_SLUG}/${id}`);
    } else if (this.entity === this.PROGRAM_SLUG && !this.isEdit) {
      this.$router.push(`/${this.PROGRAM_SLUG}/${id}/${this.LESSON_SLUG}`);
    } else {
      this.$router.push(`/${this.entity}/${id}/`);
    }
  }

  public editClicked(id: number, e) {
    e.stopPropagation();
    this.$router.push(`/${this.entity}/${id}`);
  }

  public async entityMoving(e) {
    const { draggedContext } = e;

    if (!this.moving) {
      try {
        this.moving = true;

        if (this.lockManager && this.lockManager.isLocked) {
          await this.lockManager.releaseLock();
          this.lockManager = null;
        }

        this.lockManager = new LockManager(
          draggedContext.element.SLUG,
          draggedContext.element.id
        );

        this.draggedElement = draggedContext.element;
        await this.tryToLock();
      } catch (e) {
        this.moving = false;
        this.error = true;
        return false;
      }
    }
  }

  public async entityDropped(e) {
    try {
      this.loading = true;
      await this.tryToLock();

      if (this.draggedElement) {
        let newOrder = e.newIndex;
        if (newOrder > 0) {
          newOrder = this.loadedList.results[newOrder - 1].order + 1;
        }

        this.draggedElement.order = newOrder;
        await this.draggedElement.save();
      }

      this.draggedElement = null;
      this.moving = false;

      if (this.lockManager && this.lockManager.isLocked) {
        await this.lockManager.releaseLock();
        this.lockManager = null;
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }
}
